import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useScrollRestoration, restoreScrollPos } from '../utils/useScrollRestoration';

/**
 * @summary Delay scroll restoration so that ads have a chance to render first,
 * preventing the page from appearing to jump.
 *
 * @param {React.JSXElementConstructor<any>} Component Component, preferably page, to apply this behaviour to.
 */
export function withDelayedScrollRestoration(Component) {
	return ({ ...props }) => {
		const [initialLoad, setInitialLoad] = useState(true);
		const router = useRouter();

		useEffect(() => {
			if (initialLoad) setInitialLoad(false);
		}, [initialLoad]);

		useEffect(() => {
			// wait for the ads before preserving scroll state
			setTimeout(() => {
				restoreScrollPos(router.asPath);
			}, 2000);

			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [initialLoad]);

		// Restore last location
		useScrollRestoration(router);

		return <Component {...props} />;
	};
}
